<div>
  <a
  href="https://wa.me/+5591984111946?text=Ol%C3%A1%2C%20tudo%20bem%3F"
  target="_blank"
   class="text-[35px] bg-white text-[#1c7db9] border border-[#1c7db9] p-1 rounded-full fixed bottom-5 right-6 hover:bg-[#1c7db9] hover:text-white">
    <i class='bx bxl-whatsapp'></i>
  </a>
</div>